import gql from 'graphql-tag';


export const SEND_RESET_PASSWORD_EMAIL = gql`
mutation sendResetPasswordEmail($data: SendResetPasswordEmailInput!) {
  sendResetPasswordEmail(data: $data) {
    ok
    errorMessage
    sentEmailType
  }
}
`;

export const GET_MY_JOB_APPLICATIONS = gql`
query getEmploymentsAndApplications {
  me {
    id
    acceptedCandidateOrganizations
    applications {
      edges {
        node {
          id
          acceptedByCandidateAt
          jobPosition {
            id
            name
            requireLogicTest
            requirePersonalityTest
            requireLogicIrtTest
            organization {
              id
              name
              logo
            }
          }
        }
      }
    }
  }
}
`;


export const ACCEPT_EMPLOYMENT_INVITATION_MUTATION = gql`
mutation AcceptEmploymentInvitation($organizationId: ID!) {
  acceptEmploymentInvitation(organizationId: $organizationId) {
    ok
    errorMessage
    employment {
      id
      acceptedByUserAt
    }
  }
}
`;

export const REJECT_EMPLOYMENT_INVITATION_MUTATION = gql`
mutation rejectEmploymentInvitation($organizationId: ID) {
  rejectEmploymentInvitation(organizationId: $organizationId) {
    ok
    errorMessage
  }
}
`;

export const ACCEPT_SHARING_CANDIDATE_DATA_WITH_ORGANIZATION = gql`
mutation acceptSharingCandidateDataWithOrganization($organizationId: ID!) {
  acceptSharingCandidateDataWithOrganization(organizationId: $organizationId) {
    ok
    errorMessage
    user {
      id
      acceptedCandidateOrganizations
    }
  }
}
`;

export const REJECT_SHARING_CANDIDATE_DATA_WITH_ORGANIZATION = gql`
mutation rejectSharingCandidateDataWithOrganization($organizationId: ID!) {
  rejectSharingCandidateDataWithOrganization(organizationId: $organizationId) {
    ok
    errorMessage
    user {
      id
      acceptedCandidateOrganizations
    }
  }
}
`;

export const GET_USER_ORGANIZATIONS = gql`
query getUserOrganizations {
  me {
    id
    email
    firstName
    lastName
    userOrganizations {
      id
      created
      userId
      organizationId
      organizationName
      organizationLogo
      relation
      acceptedAt
      isCandidate
      isEmployment
    }
  }
}
`;
